
import React from "react";
import { Link } from "react-router-dom";
import Navbar from './Navbar'
import Footer from './Footer'
import DirectorGrid from './DirectorGrid'

export default function Corecommitee() {
  /* Alumni directory — commented out for now
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const sheetId = "1Z1z3zT5VxW0XmexMZmzqV7dsLCoA2qFq8fbAkpeat_U";
  useEffect(() => {
    fetch(`https://opensheet.vercel.app/${sheetId}/Sheet1`)
      .then((res) => res.json())
      .then(setData)
      .catch((err) => console.error("Error fetching data:", err));
  }, []);

  const filteredData = data.filter((item) =>
    Object.values(item).some((val) =>
      val.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const handleReset = () => {
    setSearchTerm("");
  };
  */

  const membershipBenefits = [
    'Be part of an exclusive network of LIT University alumni across North America',
    'Stay connected with fellow LITians through events, retreats, and online community',
    "Receive updates on LITU's growth, new programs, and campus developments",
    'Participate in professional networking, mentoring, and knowledge-sharing opportunities',
    'Contribute to and vote on chapter initiatives and giving priorities',
    'Recognition within the global LITAA community of 6,000+ members',
    'Life members receive enhanced recognition and acknowledgment from LITAA globally',
  ];

  return (
    <>
      <div className="main-wrapper page page-membership">
        <Navbar />
        <div className="content-wrapper">
          <div className="about-us" data-aos="fade-up">
            <div className="about-us-title text-center">
              <div className="container">
                {/* Old title: Core Commitee / Our Community */}
                <h1 className="heading-bold text-uppercase">Membership</h1>
                <p className="page-hero-subtitle">
                  LITians in North America — connected, accomplished, and giving back.
                </p>
              </div>
            </div>
          </div>

          <section className="litaana-members-section" data-aos="fade-up">
            <div className="container">
              <p>
                The LIT Alumni Association North America Chapter is a community of professionals who share one of the most distinctive educational experiences in Indian engineering — a rigorous, specialized formation in chemical engineering and technology at one of the country&apos;s oldest and most respected institutions.
              </p>
              <p>
                Our members are spread across the United States and Canada, working in industries as diverse as energy, petrochemicals, pharmaceuticals, food science, materials, consulting, research, and technology. What unites us is a shared alma mater, a shared formative experience, and a shared commitment to staying connected and giving back.
              </p>

              <h3>Membership Benefits</h3>
              <ul className="members-benefits-list">
                {membershipBenefits.map((benefit) => (
                  <li key={benefit}>{benefit}</li>
                ))}
              </ul>

              <h3>Membership Options</h3>
              <div className="membership-cards">
                <div className="membership-card" data-aos="fade-up">
                  <h4>Annual Membership</h4>
                  <p className="price">$150 per year</p>
                  <p>Open to all LIT University alumni living or working in the United States or Canada.</p>
                </div>
                <div className="membership-card" data-aos="fade-up" data-aos-delay="100">
                  <h4>Life Membership</h4>
                  <p className="price">$1,500 one-time fee</p>
                  <p>A sustained commitment to the chapter and to LITAA globally, with enhanced recognition and acknowledgment within the wider alumni community.</p>
                </div>
              </div>

              <h3>Board of Directors</h3>
              <DirectorGrid showRoles={false} />

              <h3>Join the Chapter</h3>
              <p>
                If you are a LIT University alumnus living or working in North America and have not yet connected with our chapter, we warmly invite you to join. Becoming a member is simple — reach out through the Contact page and our team will guide you through the membership process.
              </p>
              <div className="members-cta-group">
                <Link to="/contactus" className="bnt bnt-theme">
                  Join the Chapter
                </Link>
              </div>

              <h3 className="members-subsection-title">Already a LITAA Member?</h3>
              <p>
                If you are already a registered member of the global LITAA network, connect with us to be added to the North America Chapter. Update your chapter affiliation and start receiving chapter-specific communications, event invitations, and giving opportunities.
              </p>
              <div className="members-cta-group">
                <Link to="/register" className="bnt bnt-theme bnt-theme--outline">
                  Connect with the NA Chapter
                </Link>
              </div>
            </div>
          </section>

          {/* Alumni directory — commented out for now
          <div className="container">
            <div className="alumni-directory" data-aos="fade-up" data-aos-delay="100">
              <div className="top-section">
                <div className="row">
                  <div className="title-page text-left col-md-6 col-sm-12 col-xs-12">
                    <h4 className="text-regular">Alumni Directory</h4>
                  </div>
                  <div className="search-alumni-directory text-right col-md-6 col-sm-12 col-xs-12">
                    <form className="navbar-form no-margin no-padding alumni-search-form">
                      <div className="alumni-search-row">
                        <input type="text" placeholder="Search..." className="form-control input-search" />
                        <button type="button" className="bg-color-theme text-center text-regular">Reset</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="alumni-directory-content">
                ...
              </div>
            </div>
          </div>
          */}
        </div>

        <Footer data-aos="fade-up" data-aos-delay={1600} />
      </div>
    </>
  )
}
